import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { loadableReady } from '@loadable/component'

import configureStore from './store/configureStore';

import { HamsterProvider } from 'hamster-react';
import configureHamster from './store/configureHamster';

import './index.scss';
import App from './containers/app/App';

import { I18nextProvider } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

const store = configureStore({
  isBrowser: true
});

const hamster = configureHamster({ store });

loadableReady(() => {
  const appRoot = window.document.getElementById('root');

  render(
    (
      <I18nextProvider i18n={ i18n }>
        <CookiesProvider>
          <Provider store={store}>
            <HamsterProvider hamster={hamster}>
              <App isBrowser={true}/>
            </HamsterProvider>
          </Provider>
        </CookiesProvider>
      </I18nextProvider>
    ),
    appRoot
  );

  if (module.hot) {
    module.hot.accept();
  }
});
